(function() {
  const APPS_SCRIPT_URL = 'https://script.google.com/macros/s/AKfycby6CF0_7pVOa06MkAtIZ4mm9OlMca5jKt3NFWFjmEweOmLfWpweEnHX7M7_SAkQdsKh/exec';
  const RECAPTCHA_SITE_KEY = '6Lehb-0sAAAAAMt_B1zWQ-aAeRUIYGpck-PfcGnr';

  const I18N = {
    tr: {
      w_eyebrow:'İÇ MİMAR & MAĞAZA', w_t1:'İç mimarlara, mağazalara', w_t2:'atölye fiyatına halı.',
      w_lede:'Müşterilerinize halı sunuyorsanız, doğrudan atölyemizden tedarik edin. Özel ölçü, renk ve desen. Süreç boyunca size atanmış tek sorumlu.',
      w_p1:'Atölye fiyatından satın alın', w_p1_s:'perakende üzerinden değil',
      w_p2:'Özel ölçü, renk, desen', w_p2_s:'ek ücret yok',
      w_p3:'Size atanmış sorumlu', w_p3_s:'WhatsApp\'tan birebir takip',
      w_cta:'BAŞVURU 60 SANİYE',
      w_t_1:'24 saatte yanıt', w_t_2:'0 risk', w_t_3:'3 kıtaya teslim',
      s1_title:'İletişim', s1_sub:'Sizinle nasıl iletişim kuralım.',
      l_ad:'Ad', l_soyad:'Soyad', l_unvan:'Unvan',
      o_select:'Seçiniz',
      t_ic:'İç Mimar', t_mimar:'Mimar', t_tas:'Tasarımcı', t_dek:'Dekoratör', t_sah:'Stüdyo Sahibi', t_dig:'Diğer',
      l_email:'E-posta', l_phone:'Telefon',
      s2_title:'Stüdyo', s2_sub:'Çalıştığınız firma hakkında.',
      l_firma:'Stüdyo adı', l_web:'Web sitesi', l_ig:'Instagram',
      h_verify:'En az birini girin — başvurunuzu doğrulamak için gereklidir.',
      t_mag:'Mağaza Sahibi',
      l_ulke:'Ülke', l_sehir:'Şehir', l_vergi:'Vergi numarası',
      h_vergi:'Trade fatura için gereklidir (TR: 10 hane · EU: VAT).',
      s3_title:'Proje', s3_sub:'Çalıştığınız alan ve hacim.',
      l_odak:'Odak alanı',
      o_res:'HIGH-END KONUT', o_res_d:'Villa, rezidans, özel ev',
      o_hos:'HOSPITALITY', o_hos_d:'Otel, restoran, kulüp',
      o_off:'OFİS · TİCARİ', o_off_d:'Plaza, ofis, lobby',
      o_ret:'MAĞAZA · SHOWROOM', o_ret_d:'Butik, perakende',
      l_hacim:'Yıllık hacim', v_s:'1–5 proje', v_m:'6–15 proje', v_l:'15+ kurumsal',
      l_notlar:'Notlarınız', opt:'opsiyonel',
      s4_title:'Geri arama', s4_sub:'Müsait olduğunuz gün ve aralığı seçin.',
      l_slot:'Saat aralığı', sl_m:'SABAH', sl_n:'ÖĞLE', sl_a:'İKİNDİ', sl_e:'AKŞAM',
      kvkk:'6698 sayılı KVKK kapsamında, bilgilerimin Carpetdocia tarafından trade başvurum için işlenmesini kabul ediyorum.',
      mkt:'Carpetdocia güncellemelerini almak istiyorum (opsiyonel).',
      back:'GERİ', next:'İLERİ', send:'GÖNDER', sending:'GÖNDERİLİYOR…',
      ok_eb:'TEŞEKKÜRLER', ok_t:'Talebiniz alındı.',
      ok_d:'Ekibimiz seçtiğiniz saatte sizi arayacaktır.', ok_close:'ANASAYFA',
      tl1:'Talep alındı', tl1s:'Şimdi',
      tl2:'Ekibimiz arar',
      tl3:'Özel teklif', tl3s:'Onay sonrası',
      ok_prose:'Ekibimiz 24 saat içinde başvurunuzu inceler ve seçtiğiniz aralıkta sizi arayacak. Onay sonrası özel ölçü teklif süreciniz başlar.',
      ok_home:'ANASAYFA', ok_ig:'@CARPETDOCIA',
      err:'Bir hata oluştu. Lütfen tekrar deneyin.',
      legal:'Bu site reCAPTCHA tarafından korunmaktadır. Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Gizlilik</a> ve <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Şartlar</a> geçerlidir.',
      months:['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'],
      weekdays:['PZT','SAL','ÇAR','PER','CUM','CMT','PAZ'],
      ty:'Teşekkürler, '
    },
    en: {
      w_eyebrow:'INTERIOR DESIGNER & RETAILER', w_t1:'For designers and retailers:', w_t2:'rugs at atelier prices.',
      w_lede:'If you supply rugs to your clients, source them directly from our atelier. Custom size, color and pattern. One dedicated point of contact throughout the project.',
      w_p1:'Buy at atelier prices', w_p1_s:'no retail markup',
      w_p2:'Custom size, color, pattern', w_p2_s:'no extra fee',
      w_p3:'Your dedicated contact', w_p3_s:'one-to-one on WhatsApp',
      w_cta:'APPLY IN 60 SECONDS',
      w_t_1:'24-hour reply', w_t_2:'Zero risk', w_t_3:'Delivery to 3 continents',
      s1_title:'Contact', s1_sub:'How to reach you.',
      l_ad:'First name', l_soyad:'Last name', l_unvan:'Title',
      o_select:'Select',
      t_ic:'Interior Designer', t_mimar:'Architect', t_tas:'Designer', t_dek:'Decorator', t_sah:'Studio Owner', t_dig:'Other',
      l_email:'Email', l_phone:'Phone',
      s2_title:'Studio', s2_sub:'About your firm.',
      l_firma:'Studio name', l_web:'Website', l_ig:'Instagram',
      h_verify:'Provide at least one — required to verify your application.',
      t_mag:'Shop Owner',
      l_ulke:'Country', l_sehir:'City', l_vergi:'Tax / VAT number',
      h_vergi:'Required for trade invoicing.',
      s3_title:'Project', s3_sub:'Your focus and volume.',
      l_odak:'Focus area',
      o_res:'HIGH-END RESIDENTIAL', o_res_d:'Villa, residence, private',
      o_hos:'HOSPITALITY', o_hos_d:'Hotel, restaurant, club',
      o_off:'OFFICE · COMMERCIAL', o_off_d:'Plaza, office, lobby',
      o_ret:'RETAIL · SHOWROOM', o_ret_d:'Boutique, retail',
      l_hacim:'Annual volume', v_s:'1–5 projects', v_m:'6–15 projects', v_l:'15+ corporate',
      l_notlar:'Notes', opt:'optional',
      s4_title:'Call-back', s4_sub:'Pick an available day and time block.',
      l_slot:'Time block', sl_m:'MORNING', sl_n:'MIDDAY', sl_a:'AFTERNOON', sl_e:'EVENING',
      kvkk:'I consent to my information being processed by Carpetdocia for my trade application (GDPR/KVKK compliant).',
      mkt:'I want to receive Carpetdocia updates (optional).',
      back:'BACK', next:'NEXT', send:'SEND', sending:'SENDING…',
      ok_eb:'THANK YOU', ok_t:'Your request is received.',
      ok_d:'Our team will call you in your selected time block.', ok_close:'HOME',
      tl1:'Request received', tl1s:'Now',
      tl2:'We call you',
      tl3:'Bespoke quote', tl3s:'After approval',
      ok_prose:'Our team reviews your application within 24 hours and calls you in your selected window. Your bespoke quote process starts after approval.',
      ok_home:'HOME', ok_ig:'@CARPETDOCIA',
      err:'Something went wrong. Please try again.',
      legal:'This site is protected by reCAPTCHA and the Google <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Privacy</a> and <a href="https://policies.google.com/terms" target="_blank" rel="noopener">Terms</a> apply.',
      months:['January','February','March','April','May','June','July','August','September','October','November','December'],
      weekdays:['MON','TUE','WED','THU','FRI','SAT','SUN'],
      ty:'Thank you, '
    }
  };

  // ===== T-LAB COMPATIBILITY FLAG =====
  // true  → built-in i18n (6 dil: TR/EN/DE/IT/FR/AR) aktif. Mevcut davranış.
  // false → built-in i18n KAPALI. T-Lab (veya başka çeviri app'i) tüm dilleri yönetir.
  // T-Lab tam kuruluma hazır olunca burayı false yap, deploy et — gerisi otomatik.
  const USE_BUILTIN_I18N = true;

  // ===== STATE =====
  let lang = (document.documentElement.lang || 'tr').slice(0,2);
  if (!I18N[lang]) lang = 'en';
  let availability = null;
  let viewDate = new Date(); viewDate.setDate(1);
  let selectedDate = null;
  let currentStep = 0;

  const STEP_FIELDS = {
    1: ['ad', 'soyad', 'unvan', 'email', 'telefon'],
    2: ['firma', 'ulke', 'sehir'],
    3: ['proje_tipi'],
    4: ['geri_arama_tarihi', 'geri_arama_aralik', 'kvkk']
  };

  // City dataset: TR all 81 il, plus major cities for top countries
  const CITIES = {
    'Türkiye': ['Adana','Adıyaman','Afyonkarahisar','Ağrı','Aksaray','Amasya','Ankara','Antalya','Ardahan','Artvin','Aydın','Balıkesir','Bartın','Batman','Bayburt','Bilecik','Bingöl','Bitlis','Bolu','Burdur','Bursa','Çanakkale','Çankırı','Çorum','Denizli','Diyarbakır','Düzce','Edirne','Elazığ','Erzincan','Erzurum','Eskişehir','Gaziantep','Giresun','Gümüşhane','Hakkari','Hatay','Iğdır','Isparta','İstanbul','İzmir','Kahramanmaraş','Karabük','Karaman','Kars','Kastamonu','Kayseri','Kırıkkale','Kırklareli','Kırşehir','Kilis','Kocaeli','Konya','Kütahya','Malatya','Manisa','Mardin','Mersin','Muğla','Muş','Nevşehir','Niğde','Ordu','Osmaniye','Rize','Sakarya','Samsun','Siirt','Sinop','Sivas','Şanlıurfa','Şırnak','Tekirdağ','Tokat','Trabzon','Tunceli','Uşak','Van','Yalova','Yozgat','Zonguldak'],
    'Almanya': ['Berlin','Hamburg','München','Köln','Frankfurt','Stuttgart','Düsseldorf','Leipzig','Dortmund','Essen','Bremen','Dresden','Hannover','Nürnberg','Duisburg','Bochum','Wuppertal','Bielefeld','Bonn','Münster','Karlsruhe','Mannheim','Augsburg','Wiesbaden','Mönchengladbach'],
    'Avusturya': ['Viyana','Graz','Linz','Salzburg','Innsbruck','Klagenfurt','Villach','Wels','Sankt Pölten','Dornbirn'],
    'Belçika': ['Brüksel','Antwerp','Ghent','Charleroi','Liège','Bruges','Namur','Leuven','Mons','Aalst'],
    'Birleşik Krallık': ['Londra','Manchester','Birmingham','Glasgow','Edinburgh','Liverpool','Leeds','Sheffield','Bristol','Cardiff','Belfast','Newcastle','Nottingham','Brighton','Oxford','Cambridge'],
    'Bulgaristan': ['Sofya','Plovdiv','Varna','Burgas','Ruse','Stara Zagora','Pleven','Sliven'],
    'Danimarka': ['Kopenhag','Aarhus','Odense','Aalborg','Esbjerg','Randers','Kolding','Horsens'],
    'Finlandiya': ['Helsinki','Espoo','Tampere','Vantaa','Oulu','Turku','Jyväskylä','Lahti'],
    'Fransa': ['Paris','Marsilya','Lyon','Toulouse','Nice','Nantes','Strasbourg','Montpellier','Bordeaux','Lille','Rennes','Reims','Le Havre','Cannes','Saint-Tropez','Aix-en-Provence'],
    'Hırvatistan': ['Zagreb','Split','Rijeka','Osijek','Zadar','Pula','Slavonski Brod','Dubrovnik'],
    'Hollanda': ['Amsterdam','Rotterdam','Lahey','Utrecht','Eindhoven','Tilburg','Groningen','Almere','Breda','Nijmegen','Haarlem','Maastricht'],
    'İrlanda': ['Dublin','Cork','Limerick','Galway','Waterford','Drogheda','Swords','Dundalk'],
    'İspanya': ['Madrid','Barselona','Valensiya','Sevilla','Zaragoza','Malaga','Murcia','Bilbao','Palma','Las Palmas','Granada','Cordoba','Marbella','Ibiza'],
    'İsveç': ['Stockholm','Göteborg','Malmö','Uppsala','Västerås','Örebro','Linköping','Helsingborg','Jönköping','Norrköping'],
    'İsviçre': ['Zürih','Cenevre','Basel','Lozan','Bern','Winterthur','Lucerne','St. Gallen','Lugano','Biel','Davos','Zermatt'],
    'İtalya': ['Roma','Milano','Napoli','Torino','Palermo','Cenova','Bologna','Floransa','Bari','Catania','Venedik','Verona','Trieste','Padova','Como','Portofino'],
    'Kıbrıs': ['Lefkoşa','Limasol','Mağusa','Girne','Larnaka','Baf'],
    'Macaristan': ['Budapeşte','Debrecen','Szeged','Miskolc','Pécs','Győr','Nyíregyháza','Kecskemét'],
    'Norveç': ['Oslo','Bergen','Trondheim','Stavanger','Drammen','Fredrikstad','Kristiansand','Tromsø'],
    'Polonya': ['Varşova','Krakov','Łódź','Wrocław','Poznań','Gdańsk','Szczecin','Bydgoszcz','Lublin','Białystok'],
    'Portekiz': ['Lizbon','Porto','Vila Nova de Gaia','Amadora','Braga','Funchal','Coimbra','Setúbal','Faro','Cascais'],
    'Romanya': ['Bükreş','Cluj-Napoca','Timișoara','Iași','Constanța','Craiova','Brașov','Galați','Sibiu','Oradea'],
    'Slovakya': ['Bratislava','Košice','Prešov','Žilina','Nitra','Banská Bystrica','Trnava'],
    'Slovenya': ['Ljubljana','Maribor','Celje','Kranj','Koper','Velenje'],
    'Yunanistan': ['Atina','Selanik','Patras','Heraklion','Larissa','Volos','Rodos','Mykonos','Santorini'],
    'Çek Cumhuriyeti': ['Prag','Brno','Ostrava','Pilsen','Liberec','Olomouc','Hradec Králové','České Budějovice'],
    'ABD': ['New York','Los Angeles','Chicago','Houston','Phoenix','Philadelphia','San Antonio','San Diego','Dallas','San Francisco','Austin','Seattle','Denver','Washington','Boston','Miami','Atlanta','Las Vegas','Portland','New Orleans','Charleston','Aspen'],
    'Kanada': ['Toronto','Montreal','Vancouver','Calgary','Edmonton','Ottawa','Winnipeg','Quebec City','Hamilton','Kitchener','Halifax','Victoria'],
    'BAE': ['Dubai','Abu Dhabi','Sharjah','Ajman','Ras Al Khaimah','Fujairah','Umm Al Quwain'],
    'Katar': ['Doha','Al Rayyan','Al Wakrah','Al Khor','Lusail'],
    'Suudi Arabistan': ['Riyad','Cidde','Mekke','Medine','Dammam','Khobar','Tabuk','Buraidah'],
    'Kuveyt': ['Kuveyt Şehri','Hawalli','Salmiya','Al Jahra','Al Ahmadi','Mubarak Al-Kabeer'],
    'Bahreyn': ['Manama','Muharraq','Riffa','Hamad Town','Isa Town','Sitra'],
    'Umman': ['Maskat','Salalah','Nizwa','Sohar','Sur','Buraimi'],
    'Lübnan': ['Beyrut','Trablus','Sayda','Tyre','Jounieh','Zahle','Baalbek','Byblos'],
    'Ürdün': ['Amman','Zarqa','Irbid','Russeifa','Aqaba','Salt','Madaba'],
    'Mısır': ['Kahire','İskenderiye','Giza','Şarm El-Şeyh','Hurghada','Luxor','Aswan','Port Said'],
    'Fas': ['Kazablanka','Rabat','Marakeş','Fes','Tangier','Agadir','Meknes','Essaouira'],
    'Tunus': ['Tunus','Sfax','Sousse','Kairouan','Bizerte','Gabes','Hammamet','Djerba'],
    'Cezayir': ['Cezayir','Oran','Constantine','Annaba','Blida','Setif','Tlemcen'],
    'Rusya': ['Moskova','Saint Petersburg','Novosibirsk','Yekaterinburg','Kazan','Soçi','Krasnodar','Vladivostok'],
    'Ukrayna': ['Kiev','Kharkov','Odessa','Dnipro','Lviv','Zaporijya','Kryvyi Rih'],
    'Azerbaycan': ['Bakü','Gence','Sumqayit','Mingachevir','Quba','Şamaxı'],
    'Gürcistan': ['Tiflis','Batum','Kutaisi','Rustavi','Zugdidi','Gori'],
    'Kazakistan': ['Almatı','Astana','Şımkent','Karaganda','Aktöbe','Taraz'],
    'Çin': ['Pekin','Şanghay','Guangzhou','Shenzhen','Chengdu','Hong Kong','Hangzhou','Wuhan','Tianjin','Xi\'an','Suzhou'],
    'Japonya': ['Tokyo','Osaka','Kyoto','Yokohama','Nagoya','Sapporo','Fukuoka','Kobe','Hiroşima','Nara'],
    'Güney Kore': ['Seul','Busan','Incheon','Daegu','Daejeon','Gwangju','Suwon','Ulsan','Jeju'],
    'Hindistan': ['Yeni Delhi','Mumbai','Bangalore','Chennai','Kolkata','Hyderabad','Pune','Ahmedabad','Jaipur','Goa'],
    'Avustralya': ['Sydney','Melbourne','Brisbane','Perth','Adelaide','Gold Coast','Canberra','Hobart'],
    'Diğer': []
  };

  const root = document.getElementById('cd5');
  const form = document.getElementById('cd5Form');
  const steps = form.querySelectorAll('.cd5-step');
  const bars = root.querySelectorAll('.cd5-bar');
  const nextBtn = document.getElementById('cd5Next');
  const backBtn = document.getElementById('cd5Back');
  const submitBtn = document.getElementById('cd5Submit');
  const submitSpan = submitBtn.querySelector('span');
  const cta = document.getElementById('cd5Cta');

  // ===== I18N =====
  function applyLang() {
    if (!USE_BUILTIN_I18N) return;  // T-Lab modu — JS textContent override etmez
    const dict = I18N[lang];
    if (!dict) return;  // Bilinmeyen dil → dokunma (T-Lab çevirsin)
    root.setAttribute('dir', lang === 'ar' ? 'rtl' : 'ltr');
    root.lang = lang;
    root.querySelectorAll('[data-i]').forEach(el => {
      const key = el.getAttribute('data-i');
      if (dict[key]) {
        if (key === 'legal') el.innerHTML = dict[key];
        else el.textContent = dict[key];
      }
    });
    renderCalendar();
  }
  if (USE_BUILTIN_I18N && typeof MutationObserver !== 'undefined') {
    new MutationObserver(() => {
      const newLang = (document.documentElement.lang || 'tr').slice(0,2);
      if (newLang !== lang && I18N[newLang]) { lang = newLang; applyLang(); }
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['lang'] });
  }

  // ===== STEPS =====
  function goToStep(n) {
    if (n < 0 || n >= steps.length) return;
    currentStep = n;
    root.setAttribute('data-step', String(n));
    steps.forEach((s, i) => s.classList.toggle('is-active', i === n));
    // Immersive mode: hide theme chrome during steps 1-4 (only when NOT in overlay mode)
    if (!document.getElementById('cd5Overlay')) {
      document.body.classList.toggle('cd5-immersive', n >= 1 && n <= 4);
    }
    bars.forEach((b, i) => {
      const num = i + 1;
      b.classList.toggle('is-done', num < n);
      b.classList.toggle('is-active', num === n);
    });
    backBtn.hidden = (n <= 1);
    nextBtn.hidden = (n === 0 || n >= 4);
    submitBtn.hidden = (n !== 4);
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if (n >= 1 && n <= 4) {
      setTimeout(() => {
        const el = steps[n].querySelector('input:not([type="hidden"]):not([type="radio"]):not([type="checkbox"]), select, textarea');
        if (el) el.focus({ preventScroll: true });
      }, 200);
    }
  }

  function validateStep(n) {
    const fields = STEP_FIELDS[n] || [];
    let ok = true;
    let firstMissing = null;
    for (const name of fields) {
      const els = form.elements[name];
      if (!els) continue;
      const isGroup = els.length !== undefined && els[0] && (els[0].type === 'radio' || els[0].type === 'checkbox');
      if (isGroup) {
        const checked = Array.from(els).some(e => e.checked);
        if (!checked) {
          ok = false;
          const container = els[0].closest('.cd5-seg, .cd5-check, fieldset');
          if (container) container.classList.add('is-err');
          if (!firstMissing) firstMissing = container || els[0];
        } else {
          const container = els[0].closest('.cd5-seg, .cd5-check, fieldset');
          if (container) container.classList.remove('is-err');
        }
      } else if (els.type === 'hidden') {
        if (!els.value) {
          ok = false;
          const wrap = els.closest('.cd5-cal, .cd5-field, fieldset') || els.parentElement;
          if (wrap) wrap.classList.add('is-err');
          if (!firstMissing) firstMissing = wrap || els;
        } else {
          const wrap = els.closest('.cd5-cal, .cd5-field, fieldset') || els.parentElement;
          if (wrap) wrap.classList.remove('is-err');
        }
      } else if (els.type === 'checkbox') {
        const row = els.closest('.cd5-check__row') || els.parentElement;
        if (!els.checked) {
          ok = false;
          if (row) row.classList.add('is-err');
          if (!firstMissing) firstMissing = row || els;
        } else {
          if (row) row.classList.remove('is-err');
        }
      } else {
        const val = (els.value || '').trim();
        if (!val) {
          ok = false;
          if (els.classList) { els.classList.add('is-err'); }
          if (!firstMissing) firstMissing = els;
        } else if (els.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(val)) {
          ok = false;
          if (els.classList) { els.classList.add('is-err'); }
          if (!firstMissing) firstMissing = els;
        } else {
          if (els.classList) els.classList.remove('is-err');
        }
      }
    }
    if (!ok && firstMissing) {
      try {
        firstMissing.scrollIntoView({ behavior: 'smooth', block: 'center' });
        if (typeof firstMissing.focus === 'function') firstMissing.focus({ preventScroll: true });
      } catch (e) {}
    }
    return ok;
  }

  // City dropdown population
  const ulkeSel = document.getElementById('f-ulke');
  const sehirSel = document.getElementById('f-sehir');
  function populateCities(country) {
    const list = CITIES[country] || [];
    const dict = I18N[lang] || I18N.tr;
    sehirSel.innerHTML = `<option value="" disabled selected>${dict.o_select || 'Seçiniz'}</option>` +
      list.map(c => `<option value="${c}">${c}</option>`).join('') +
      (list.length ? `<option value="__other">${lang === 'en' ? 'Other' : 'Diğer'}</option>` : `<option value="__manual">${lang === 'en' ? 'Type city' : 'Yazarak girin'}</option>`);
  }
  ulkeSel.addEventListener('change', () => populateCities(ulkeSel.value));
  sehirSel.addEventListener('change', () => {
    if (sehirSel.value === '__other' || sehirSel.value === '__manual') {
      const inp = prompt(lang === 'en' ? 'Type your city' : 'Şehir adını yazın');
      if (inp && inp.trim()) {
        const opt = document.createElement('option');
        opt.value = inp.trim();
        opt.textContent = inp.trim();
        opt.selected = true;
        sehirSel.insertBefore(opt, sehirSel.querySelector('option[value="__other"], option[value="__manual"]'));
      } else {
        sehirSel.selectedIndex = 0;
      }
    }
  });
  // Init Türkiye cities
  populateCities('Türkiye');

  // Web OR Instagram validation
  const webEl = document.getElementById('f-web');
  const igEl = document.getElementById('f-ig');
  function validateWebOrInstagram() {
    const hasWeb = (webEl.value || '').trim().length > 0;
    const hasIg = (igEl.value || '').trim().length > 0;
    if (!hasWeb && !hasIg) {
      webEl.classList.add('is-err');
      igEl.classList.add('is-err');
      return false;
    }
    webEl.classList.remove('is-err');
    igEl.classList.remove('is-err');
    return true;
  }

  document.querySelectorAll('[data-next]').forEach(b => {
    b.addEventListener('click', () => {
      if (currentStep > 0 && !validateStep(currentStep)) return;
      if (currentStep === 2 && !validateWebOrInstagram()) return;
      goToStep(currentStep + 1);
    });
  });
  document.querySelectorAll('[data-prev]').forEach(b => {
    b.addEventListener('click', () => goToStep(currentStep - 1));
  });
  form.querySelectorAll('input, textarea, select').forEach(el => {
    el.addEventListener('input', () => {
      el.classList.remove('is-err');
      const wrap = el.closest('.cd5-seg, .cd5-fset, .cd5-cal, .cd5-check__row');
      if (wrap) wrap.classList.remove('is-err');
    });
    el.addEventListener('change', () => {
      el.classList.remove('is-err');
      const wrap = el.closest('.cd5-seg, .cd5-fset, .cd5-cal, .cd5-check__row');
      if (wrap) wrap.classList.remove('is-err');
    });
  });

  // ===== EMAIL AUTOCOMPLETE =====
  const EMAIL_DOMAINS = ['gmail.com','yandex.com','yahoo.com','hotmail.com','outlook.com','icloud.com','protonmail.com','live.com','msn.com'];
  const emailInput = document.getElementById('f-email');
  const emailSuggest = document.getElementById('emailSuggest');

  emailInput.addEventListener('input', () => {
    const v = emailInput.value;
    if (!v || v.length < 2) { emailSuggest.hidden = true; return; }
    const atIdx = v.indexOf('@');
    let local, partial;
    if (atIdx === -1) { local = v; partial = ''; }
    else { local = v.slice(0, atIdx); partial = v.slice(atIdx + 1).toLowerCase(); }
    if (!local) { emailSuggest.hidden = true; return; }
    const matches = EMAIL_DOMAINS.filter(d => partial === '' || d.startsWith(partial)).slice(0, 6);
    if (!matches.length) { emailSuggest.hidden = true; return; }
    emailSuggest.innerHTML = matches.map(d => `<div class="cd5-suggest__item" data-mail="${local}@${d}">${local}@${d}</div>`).join('');
    emailSuggest.hidden = false;
    emailSuggest.querySelectorAll('.cd5-suggest__item').forEach(item => {
      item.addEventListener('mousedown', (e) => {
        e.preventDefault();
        emailInput.value = item.dataset.mail;
        emailSuggest.hidden = true;
      });
    });
  });
  emailInput.addEventListener('blur', () => setTimeout(() => emailSuggest.hidden = true, 150));

  // ===== PHONE FORMAT =====
  const telInput = document.getElementById('f-tel');
  const tcodeInput = document.getElementById('f-tcode');
  telInput.addEventListener('input', () => {
    if (tcodeInput.value === '+90') {
      let v = telInput.value.replace(/\D/g, '').slice(0, 10);
      let out = '';
      if (v.length > 0) out += v.slice(0,3);
      if (v.length > 3) out += ' ' + v.slice(3,6);
      if (v.length > 6) out += ' ' + v.slice(6,8);
      if (v.length > 8) out += ' ' + v.slice(8,10);
      telInput.value = out;
    }
  });

  // ===== CALENDAR =====
  const calGrid = document.getElementById('calGrid');
  const calWd = document.getElementById('calWd');
  const calTitle = document.getElementById('calTitle');
  const calPrev = document.getElementById('calPrev');
  const calNext = document.getElementById('calNext');
  const tarihInput = document.getElementById('f-tarih');

  function dKey(d) {
    return d.getFullYear() + '-' + String(d.getMonth()+1).padStart(2,'0') + '-' + String(d.getDate()).padStart(2,'0');
  }
  function renderCalendar() {
    if (!calGrid) return;
    const dict = I18N[lang] || I18N.tr;
    const yr = viewDate.getFullYear();
    const mo = viewDate.getMonth();
    calTitle.textContent = `${dict.months[mo]} ${yr}`;
    calWd.innerHTML = dict.weekdays.map(d => `<span>${d}</span>`).join('');

    const today = new Date(); today.setHours(0,0,0,0);
    const first = new Date(yr, mo, 1);
    const last = new Date(yr, mo+1, 0);
    let fd = first.getDay() - 1; if (fd < 0) fd = 6;
    let html = '';
    for (let i = 0; i < fd; i++) html += `<div class="cd5-day is-other"></div>`;
    for (let d = 1; d <= last.getDate(); d++) {
      const dt = new Date(yr, mo, d);
      const k = dKey(dt);
      const isPast = dt < today;
      const isToday = dt.getTime() === today.getTime();
      const isSel = selectedDate === k;
      let cls = 'cd5-day';
      if (isPast) cls += ' is-past';
      if (isToday) cls += ' is-today';
      if (isSel) cls += ' is-sel';
      html += `<button type="button" class="${cls}" data-date="${k}" ${isPast?'disabled':''}>${d}</button>`;
    }
    calGrid.innerHTML = html;
    calGrid.querySelectorAll('.cd5-day:not(:disabled)').forEach(b => {
      b.addEventListener('click', () => {
        selectedDate = b.dataset.date;
        tarihInput.value = selectedDate;
        updateSlots();
        renderCalendar();
      });
    });
    const minMo = new Date(today.getFullYear(), today.getMonth(), 1);
    calPrev.disabled = viewDate.getTime() <= minMo.getTime();
  }
  if (calPrev) calPrev.addEventListener('click', () => { viewDate.setMonth(viewDate.getMonth() - 1); renderCalendar(); });
  if (calNext) calNext.addEventListener('click', () => { viewDate.setMonth(viewDate.getMonth() + 1); renderCalendar(); });

  function updateSlots() {
    const SLOT_END_HOUR = { sabah: 12, ogle: 15, ikindi: 18, aksam: 20 };
    const chips = document.querySelectorAll('#slotChips label');

    // Eğer bir tarih seçilmemişse, tüm slotlar açık
    if (!selectedDate) {
      chips.forEach(chip => {
        chip.classList.remove('is-disabled');
        chip.querySelector('input').disabled = false;
      });
      return;
    }

    // Bugün mü?
    const now = new Date();
    const todayStr = now.getFullYear() + '-' +
      String(now.getMonth() + 1).padStart(2, '0') + '-' +
      String(now.getDate()).padStart(2, '0');
    const isToday = selectedDate === todayStr;
    const currentHour = now.getHours();

    chips.forEach(chip => {
      const slot = chip.dataset.slot;
      const endHour = SLOT_END_HOUR[slot];
      // Bugün ise ve slot bitiş saati şu anki saate ≤ ise disable
      const isPast = isToday && (currentHour >= endHour);

      chip.classList.toggle('is-disabled', isPast);
      const inp = chip.querySelector('input');
      inp.disabled = isPast;
      // Geçmiş slot seçili kalmışsa otomatik kaldır
      if (isPast && inp.checked) inp.checked = false;
    });
  }

  async function fetchAvailability() {
    try {
      const r = await fetch(APPS_SCRIPT_URL + '?action=availability');
      const d = await r.json();
      if (d.ok && Array.isArray(d.availability)) {
        availability = d.availability;
        renderCalendar();
      }
    } catch (e) {}
  }

  // ===== RECAPTCHA =====
  function getRecaptchaToken() {
    return new Promise((resolve, reject) => {
      if (typeof grecaptcha === 'undefined') { reject(new Error('no_recaptcha')); return; }
      grecaptcha.ready(() => grecaptcha.execute(RECAPTCHA_SITE_KEY, {action:'submit'}).then(resolve).catch(reject));
    });
  }

  // IP + geo lookup (ipapi.co, free 1000/day, no key). 2sn timeout — fail olursa submit yine geçer.
  async function getClientIPInfo() {
    try {
      const ctrl = new AbortController();
      const t = setTimeout(() => ctrl.abort(), 2000);
      const r = await fetch('https://ipapi.co/json/', { signal: ctrl.signal });
      clearTimeout(t);
      if (!r.ok) return {};
      const d = await r.json();
      return {
        ip: d.ip || '',
        ip_city: d.city || '',
        ip_region: d.region || '',
        ip_country: d.country_name || '',
        ip_country_code: d.country_code || '',
        ip_postal: d.postal || '',
        ip_latitude: d.latitude || '',
        ip_longitude: d.longitude || '',
        ip_timezone: d.timezone || '',
        ip_org: d.org || '',
        ip_asn: d.asn || ''
      };
    } catch (e) { return {}; }
  }


  // ===== SUBMIT =====
  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (!validateStep(4)) return;

    const dict = I18N[lang] || I18N.tr;
    submitBtn.disabled = true;
    submitSpan.textContent = dict.sending;

    try {
      const [token, ipInfo] = await Promise.all([
        getRecaptchaToken(),
        getClientIPInfo()
      ]);
      const fd = new FormData(form);
      const _ad = fd.get('ad') || '';
      const _soyad = fd.get('soyad') || '';
      const payload = {
        ...ipInfo,
        // Backward compat with v2 Apps Script
        yetkili: (_ad + ' ' + _soyad).trim(),
        ad: _ad,
        soyad: _soyad,
        unvan: fd.get('unvan'),
        email: fd.get('email'),
        telefon_kodu: fd.get('telefon_kodu'),
        telefon: fd.get('telefon'),
        firma: fd.get('firma'),
        website: fd.get('website') || '',
        instagram: fd.get('instagram') || '',
        ulke: fd.get('ulke'),
        sehir: fd.get('sehir'),
        vergi_no: '',
        proje_tipi: fd.getAll('proje_tipi').join(', '),
        hacim: fd.get('hacim') || '',
        mesaj: fd.get('mesaj') || '',
        geri_arama_tarihi: fd.get('geri_arama_tarihi'),
        geri_arama_aralik: fd.get('geri_arama_aralik'),
        kvkk: fd.get('kvkk') === '1' || form.elements['kvkk'].checked,
        marketing: fd.get('marketing') === '1' || form.elements['marketing'].checked,
        _honey: fd.get('_honey') || '',
        lang: lang,
        recaptcha_token: token
      };
      const res = await fetch(APPS_SCRIPT_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
        redirect: 'follow'
      });
      let result = null;
      try { result = await res.json(); } catch {}
      if (result && result.ok === false) throw new Error(result.error || 'failed');

      // META PIXEL — Lead (canonical) + SubmitApplication (custom, kullanıcının ilk kodundan)
      try {
        if (typeof fbq === 'function') {
          const eventID = 'lead_' + Date.now() + '_' + Math.random().toString(36).slice(2, 8);
          fbq('track', 'Lead', {
            content_name: 'Carpetdocia Trade Application',
            content_category: 'Trade Program',
            value: 0,
            currency: 'TRY'
          }, { eventID: eventID });
          fbq('trackCustom', 'SubmitApplication', {
            project_focus: payload.proje_tipi,
            annual_volume: payload.hacim,
            country: payload.ulke,
            title: payload.unvan
          });
        }
        if (typeof window.dataLayer !== 'undefined') {
          window.dataLayer.push({
            event: 'generate_lead',
            form_name: 'ic-mimari-trade',
            project_focus: payload.proje_tipi,
            annual_volume: payload.hacim,
            country: payload.ulke,
            title: payload.unvan
          });
        }
      } catch (e) { console.warn('Pixel error', e); }

      // Success state
      const okName = document.getElementById('okName');
      const okWhen = document.getElementById('okWhen');
      const tlWhen = document.getElementById('tlWhen');
      if (okName && payload.ad) {
        okName.textContent = dict.ty + payload.ad;
      }
      const slotMap = { sabah:'09:00–12:00', ogle:'12:00–15:00', ikindi:'15:00–18:00', aksam:'18:00–20:00' };
      const dt = new Date(payload.geri_arama_tarihi);
      const monthName = dict.months[dt.getMonth()];
      const dateLine = `${dt.getDate()} ${monthName} · ${slotMap[payload.geri_arama_aralik] || ''}`;
      if (okWhen) okWhen.textContent = dateLine;
      if (tlWhen) tlWhen.textContent = dateLine;

      goToStep(5);
    } catch (err) {
      console.error('Submit error', err);
      alert(dict.err);
    } finally {
      submitBtn.disabled = false;
      submitSpan.textContent = dict.send;
    }
  });

  // ===== OVERLAY / IMMERSIVE MODE =====
  const overlayEl = document.getElementById('cd5Overlay');
  const isOverlayMode = !!overlayEl;
  const isIcMimariPath = location.pathname.replace(/\/$/, '').toLowerCase().endsWith('/pages/ic-mimari');

  function cd5OpenOverlay() {
    if (!overlayEl) return;
    overlayEl.classList.add('is-open');
    document.body.classList.add('cd5-overlay-open');
    goToStep(0);
  }
  function cd5CloseOverlay() {
    if (overlayEl) {
      overlayEl.classList.remove('is-open');
      document.body.classList.remove('cd5-overlay-open');
      document.body.classList.remove('cd5-immersive');
      try { history.replaceState({}, '', location.pathname); } catch (e) {}
    }
  }
  window.cd5Close = function() {
    if (isOverlayMode) {
      cd5CloseOverlay();
    } else {
      // Immersive (legacy ic-mimari page) — go back without nav noise
      if (document.referrer && document.referrer.indexOf(location.host) > -1) {
        history.back();
      } else {
        location.replace('/');
      }
    }
  };
  window.cd5Open = cd5OpenOverlay;

  // ===== INIT =====
  applyLang();
  fetchAvailability();
  goToStep(0);

  // Overlay mode: stay closed unless ?trade=open or #trade
  if (isOverlayMode) {
    const params = new URLSearchParams(location.search);
    const wantOpen = params.get('trade') === 'open' || location.hash === '#trade';
    if (wantOpen) cd5OpenOverlay();
    // Listen for click on any [data-cd5-open] anchor
    document.addEventListener('click', function(e) {
      const t = e.target.closest && e.target.closest('[data-cd5-open]');
      if (t) {
        e.preventDefault();
        cd5OpenOverlay();
        try { history.pushState({cd5:true}, '', '/?trade=open'); } catch (err) {}
      }
    });
    // Browser back closes overlay
    window.addEventListener('popstate', function() {
      if (overlayEl.classList.contains('is-open')) cd5CloseOverlay();
    });
  }
})();